<crm-single-select
  #singleSelectComponent
  [options]="payerStatuses"
  [(selectedItem)]="_selectedPayerStatus"
  (selectedItemChange)="onSelectChange($event)"
  [label]="labelInput ? 'КБК' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="34"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  [showClear]="showClear"
  filterBy="name,code">
  <ng-template
    #itemTemplate
    let-status="item">
    <ng-container *ngIf="toStatus(status) as status">
      <p class="font-medium">
        <span [innerHTML]="highlightMatchText(status.name) | safeHtml"></span>
      </p>
      <p class="font-bold text-green-500">{{ status.code }}</p>
    </ng-container>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
